document.addEventListener('DOMContentLoaded', () => {
  const modal_trigger = 'modal-location';

  const modal = document.querySelector('[data-' + modal_trigger + ']');
  let previouslyFocused = null;

  function openModal() {
    previouslyFocused = document.activeElement;
    modal.classList.remove('hidden');
    modal.removeAttribute('inert');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('role', 'dialog');
    document.body.style.overflow = 'hidden';
    modal.setAttribute('tabindex', '-1');
    modal.focus();
  }

  function closeModal() {
    modal.classList.add('hidden');
    modal.setAttribute('inert', '');
    modal.removeAttribute('aria-modal');
    modal.removeAttribute('role');
    modal.removeAttribute('tabindex');
    document.body.style.overflow = '';
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function removeModalHash(){
    if (window.location.hash === '#' + modal_trigger) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    }
  }

  modal.addEventListener('keydown', (e) => {
    switch (e.key) {
      case 'Escape':
        removeModalHash();
        break;
      case 'Tab': 
        const focusable = modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
        break;
    }
  });

  modal.addEventListener('click', (e) => {
    if (e.target === modal) {
      removeModalHash();
    }
  });

  modal.querySelectorAll('.close-modal').forEach((button) => {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      removeModalHash();
    });
  });

  if (window.location.hash === '#' + modal_trigger) {
    openModal();
  }

  window.addEventListener('hashchange', () => {
    if (window.location.hash === '#' + modal_trigger) {
      openModal();
    } else {
      closeModal();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const clearGroup = (group) => {
    if (!group) return;

    group.innerHTML = '';
  }

  const fillTemplate = (group, templateName, placeholders) => {
    const template = group.closest('.location-popup')?.querySelector(`template.location-popup-form-template-${templateName}`);
    if (!template) return '';

    let html = template.innerHTML;
    for (const [key, value] of Object.entries(placeholders)) {
      const regex = new RegExp(`{{\\s*${key}\\s*}}`, 'g');
      html = html.replace(regex, value);
    }
    return html;
  }

  const populateGroup = (group, locations) => {
    if (!group) return;

    clearGroup(group);

    const name = group.dataset.name;

    Object.values(locations).forEach((location) => {
      const content = fillTemplate(group, 'location', { name: location.name });
      const input = fillTemplate(group, 'item', {
        name,
        value: location.id,
        content,
      });
      group.insertAdjacentHTML('beforeend', input);
    });
  }

  const populateGroupVenues = (group, locations) => {
    if (!group) return;

    clearGroup(group);

    const name = group.dataset.name;

    Object.values(locations).forEach((location) => {
      const image = location.image? fillTemplate(group, 'image', { image: location.image, srcset: location.srcset, alt: location.name }) : '';
      const content = fillTemplate(group, 'venue', { name: location.name, description: location.description, image });
      const input = fillTemplate(group, 'item', {
        name,
        value: location.id,
        content,
      });
      group.insertAdjacentHTML('beforeend', input);
    });
  }

  const locations = get_locations(true);
  const form = document.querySelector('[data-modal-location] .location-popup-form');
  const countryGroup = form.querySelector('.location-popup-form-group[data-name="country"]');
  const provinceGroup = form.querySelector('.location-popup-form-group[data-name="province"]');
  const venueGroup = form.querySelector('.location-popup-form-group[data-name="venue"]');
    
  populateGroup(countryGroup, locations);

  const updateGroupsOptions = (target) => {
    const selectedCountry = form.querySelector('[name="country"]:checked')?.value;
    const selectedProvince = form.querySelector('[name="province"]:checked')?.value;

    countryGroup.dataset.selectedCountry = selectedCountry || '';
    provinceGroup.dataset.selectedProvince = selectedProvince || '';

    if (target === 'country') {
      if(selectedCountry){
        const options = locations[selectedCountry]['children'];
        clearGroup(venueGroup);
        populateGroup(provinceGroup, options);
      }else{
        clearGroup(provinceGroup);
        clearGroup(venueGroup);
      }
    } else if (target === 'province') {
      if(selectedProvince){
        const optionIds = locations[selectedCountry]['children'][selectedProvince]['venues'];
        const options = [];

        for (const optionId of optionIds){
          const venue = get_venue_info(optionId);
          if(venue){
            options.push(venue);
          }
        }

        populateGroupVenues(venueGroup, options);
      }else{
        clearGroup(venueGroup);
      }
    }
  }

  form.addEventListener('change', (e) => {
    updateGroupsOptions(e.target.name);
  });

  const mobileClickHandler = (e) => {
    if (window.innerWidth >= 768) return;

    const target = e.target;
    const input = target.closest('label')?.querySelector('input');
    if (!input) return;

    if ( 
      input.name === 'country' && input.value == countryGroup.dataset.selectedCountry ||
      input.name === 'province' && input.value == provinceGroup.dataset.selectedProvince
    ) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      input.checked = false;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (input.name === 'venue') {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  form.addEventListener('touchend', mobileClickHandler);
  form.addEventListener('click', mobileClickHandler);

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const selectedVenue = form.querySelector('[name="venue"]:checked')?.value;

    if(!selectedVenue) return;

    set_venue(selectedVenue);

    history.replaceState(null, '', window.location.pathname + window.location.search);
    window.dispatchEvent(new HashChangeEvent('hashchange'));
  });    

  const updateSelectedLocation = () => {
    const venue = get_venue();
    
    if (venue) {
      Object.values(locations).forEach(country => {
        Object.values(country.children || {}).forEach(province => {
          Object.values(province.venues || {}).forEach(v => {
            if (v == venue) {                
              form.querySelector('[name="country"][value="' + country.id + '"]').checked = true;
              updateGroupsOptions('country');
              form.querySelector('[name="province"][value="' + province.id + '"]').checked = true;
              updateGroupsOptions('province');
              form.querySelector('[name="venue"][value="' + venue + '"]').checked = true;
            }
          });
        });
      });
    }
  }

  const locateButton = form.closest('.location-popup').querySelector('.location-popup-locate');
  locateButton.addEventListener('click', (event) => {
    event.preventDefault();
    locateButton.disabled = true;
    locateButton.classList.add('animate-pulse');
    
    document.body.addEventListener('venueChanged', () => {
      updateSelectedLocation();
      //history.replaceState(null, '', window.location.pathname + window.location.search);
      //window.dispatchEvent(new HashChangeEvent('hashchange'));
    }, { once: true });

    set_venue_by_coordinates(() => {
      locateButton.disabled = false;
      locateButton.classList.remove('animate-pulse');
    });
  });
});